<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      checkingForUpdates: false
    }
  },
  mounted() {
    // 如果是生产环境，启动版本检查
    if (process.env.NODE_ENV === 'production') {
      // 页面加载时检查一次
      this.checkForUpdates();
      
      // 每10分钟检查一次更新
      setInterval(() => {
        this.checkForUpdates();
      }, 10 * 60 * 1000);
    }
  },
  methods: {
    checkForUpdates() {
      if (this.checkingForUpdates) return;
      this.checkingForUpdates = true;
      
      // 添加时间戳参数避免缓存
      fetch(`/version.json?t=${new Date().getTime()}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          const localVersion = localStorage.getItem('app-version');
          // 如果本地版本不存在或与最新版本不一致，保存新版本并提示刷新
          if (!localVersion || localVersion !== data.version) {
            localStorage.setItem('app-version', data.version);
            
            // 如果是首次访问，只保存版本号，不提示更新
            if (localVersion) {
              // 使用Element UI提示更新
              this.$message({
                message: '应用有新版本可用，请刷新页面',
                type: 'info',
                duration: 0,
                showClose: true,
                onClose: () => {
                  window.location.reload(true);
                }
              });
            }
          }
        })
        .catch(error => {
          console.error('检查更新出错:', error);
        })
        .finally(() => {
          this.checkingForUpdates = false;
        });
    }
  }
}
</script>

<style lang="scss">
html,body{
  height: 100%;
}
body{
  margin: 0;
  background-color: #18181b;
  height: 100%;
}
#app{
  height: 100%;
}
</style>
